var $ = jQuery;

$(document).ready(function () {
  if (
    window.location.pathname == "/contact-us/" &&
    window.localStorage.formtext
  ) {
    $("#form-field-message").val(window.localStorage.formtext);
    window.localStorage.removeItem("formtext");
  }

  if (!sessionStorage.ctaData) {
    $.get("/wp-json/acf/v3/options/options", function (data) {
      sessionStorage.ctaData = JSON.stringify(data.acf.menu_call_to_actions);
      window.ctaData = data.acf.menu_call_to_actions;
    });
  } else {
    window.ctaData = JSON.parse(sessionStorage.ctaData);
  }

  if ($(".onlinetrainingform").length > 0) {
    if (
      getCookie("OnlineCourse") == "signedup" ||
      localStorage.OnlineCourse === "signedup"
    ) {
      $(".onlinetrainingform").hide();
      $(".elearningcourse").show();
    }

    $(".elementor-editor-active .onlinetrainingform").show();
    $(".elementor-editor-active .elearningcourse").show();
  }

  // $(".videogallery .gallery-item-caption-wrap.caption-style-card").on("click", function() {
  //   var video = $(this).parent().find("a").click();
  // });

  if (!$("body").hasClass("dropdown-menus-enabled")) {
    $("#menu-main-menu .menu-item-has-children a:not(.submenu a)").on(
      "click",
      function (e) {
        e.preventDefault();
        if (e.offsetX > this.offsetWidth) {
          $(this).parent().addClass("active");
          $(this)
            .parent()
            .siblings(".menu-item-has-children")
            .removeClass("active");
        } else {
          location.href = $(this).attr("href");
        }
      }
    );

    $("#mobile-hamburger").on("click", function () {
      if ($("#site-navigation").hasClass("nav-open")) {
        $("#site-navigation").removeClass("nav-open");
        $("#site-navigation").addClass("nav-closed");
        $("body").removeClass("overflow-hidden");
      } else {
        $("#site-navigation").addClass("nav-open");
        $("#site-navigation").removeClass("nav-closed");
        $("body").addClass("overflow-hidden");
      }
    });

    $(window).on("resize", function () {
      if ($(window).width() > 1024) {
        $("#site-navigation").removeClass("nav-open");
        $("#site-navigation").addClass("nav-closed");
        $("body").removeClass("overflow-hidden");
      }
    }).resize();

    $("#site-navigation #nav-close").on("click", function () {
      $("#site-navigation").removeClass("nav-open");
      $("#site-navigation").addClass("nav-closed");
      $("body").removeClass("overflow-hidden");
    });

    $("#menu-main-menu .menu-item-has-children a:not(.submenu a)").hover(
      function () {
        var that = $(this);

        if (!that.parent().parent().hasClass("sub-menu")) {
          var subMenu = $(this).parent().find(".sub-menu");

          for (var i = 0; i < window.ctaData.length; i++) {
            if (
              window.ctaData[i].id.toLowerCase() ==
              that[0].innerHTML.toLowerCase()
            ) {
              if (subMenu.find(".upsell").length == 0) {
                subMenu.append(`
                <li class="upsell">
                  <a style="background: url(${window.ctaData[i].image.sizes.medium_large}) no-repeat center center / cover;"
                    href="${window.ctaData[i].link.url}">
                      <span>${window.ctaData[i].link.title}</span>
                      <span>find out more ></span>
                    </a>
                </li>`);
              }
            }
          }

          setTimeout(function () {
            $("li.close a").click(function () {
              $(".menu-item-has-children").removeClass("active");
            });
          }, 100);
        }
      }
    );
  } else {
    $("#menu-main-menu .menu-item-has-children a:not(.submenu a)").hover(
      function () {
        var that = $(this);

        if (!that.parent().parent().hasClass("sub-menu")) {
          var subMenu = $(this).parent().find(".sub-menu");

          for (var i = 0; i < window.ctaData.length; i++) {
            if (
              window.ctaData[i].id.toLowerCase() ==
              that[0].innerHTML.toLowerCase()
            ) {
              if (subMenu.find(".upsell").length == 0) {
                subMenu.append(`
                <li class="upsell">
                  <a style="background: url(${window.ctaData[i].image.sizes.medium_large}) no-repeat center center / cover;"
                    href="${window.ctaData[i].link.url}">
                      <span>${window.ctaData[i].link.title}</span>
                      <span>find out more ></span>
                    </a>
                </li>`);
              }
            }
          }
        }
      }
    );
  }

  function handleMobileMenu(e, that) {
    if (!that.parent().parent().hasClass("sub-menu")) {
      if (e.offsetX < that.width() - 30) {
        return;
      }

      e.preventDefault();
      $(".menu-item-has-children").removeClass("active");

      that.parent().addClass("active");
      //var subMenu = that.parent().find(".sub-menu");
    }
  }

  // We need to watch for the jQuery selector, as the popup is generated through AJAX
  setInterval(function () {
    var mobileMenuSelector = $(
      ".mobilemenu .menu-item-has-children a:not(.submenu a)"
    );

    if (mobileMenuSelector.length > 0) {
      var ev = $._data(mobileMenuSelector[0], "events");

      if (!ev || !ev.click) {
        mobileMenuSelector.on("click", function (e) {
          var that = $(this);
          handleMobileMenu(e, that);
        });
      }
    }
  }, 200);

  if (
    window.location.pathname == "/e-learning-course/" ||
    window.location.pathname == "/brew-course/"
  ) {
    var val = "";
    var name = "OnlineCourse" + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        val = c.substring(name.length, c.length);
      }
    }

    if (val != "signedup" && localStorage.OnlineCourse !== "signedup") {
      window.location = "/elearning-please-register/";
    }
  }

  /** Recipe filter */
  $(".select-hover span input.filter-search").on("focus", function () {
    $(".select-hover").removeClass("active");
    $(this).parents(".select-hover").addClass("active");
  });

  $(".select-hover span.clear-input").on("click", function () {
    $(this).parents(".select-hover span").removeClass("has-text");
    $(this)
      .parents(".select-hover")
      .find("input.filter-search")
      .val("")
      .trigger("change");

    /** Show all list items */
    $(this).parents(".select-hover").find("ul li").show();
  });

  var findOne = function (haystack, arr) {
    return arr.some(function (v) {
      return haystack.indexOf(v) >= 0;
    });
  };

  $(".select-hover li").on("click", function () {
    var $self = $(this);

    if ($self.parents(".select-hover").hasClass("multiple")) {
      if ($self.attr("data-filter").indexOf("*") >= 0) {
        $self
          .parents("ul")
          .find('li:not([data-filter$="*"])')
          .removeClass("item-selected");
        $self.toggleClass("item-selected");
      } else {
        $self
          .parents("ul")
          .find('li[data-filter$="*"]')
          .removeClass("item-selected");
        $self.toggleClass("item-selected");
      }
    } else {
      $self.parents("ul").find("li").removeClass("item-selected");
      $self.toggleClass("item-selected");
    }

    /**
     * Loop through all elements in the grid.
     * Hide all and show the ones with matching classes
     */
    var filterClassList = [];

    $(".select-hover").each(function () {
      $(this)
        .find("li.item-selected")
        .each(function () {
          var filter = $(this).attr("data-filter");

          if (filter.indexOf("*") >= 0) {
            $(this)
              .parents("ul")
              .find('li:not([data-filter="' + filter + '"]')
              .each(function () {
                var filterNew = $(this).attr("data-filter");

                filterClassList.push(filterNew);
              });
          } else {
            filterClassList.push(filter);
          }
        });
    });

    if (filterClassList.length > 0) {
      $(".recipe-card").each(function () {
        var filters = $(this).attr("data-filters").split(" "),
          exists = findOne(filterClassList, filters);

        if (exists) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    } else {
      $(".recipe-card").show();
    }
  });

  $(".select-hover span input.filter-search").on("keyup", function () {
    // Declare variables
    var input, filter, ul, li, txtValue;
    input = $(this);
    filter = input.val().toUpperCase();
    ul = input.parents(".select-hover").find("ul");
    li = ul.find("li");

    // Loop through all list items, and hide those who don't match the search query
    $(li).each(function () {
      txtValue = $(this).text();

      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    var liCount = $(li).length;

    if (ul.find("li.dropdown-item:hidden").length === Number(liCount) - 1) {
      ul.find("li.no-matching").show();
    } else {
      ul.find("li.no-matching").hide();
    }

    if ($(this).val().length > 0) {
      $(this).parents("span").addClass("has-text");
    } else {
      $(this).parents("span").removeClass("has-text");
    }
  });

  $(document).click(function (e) {
    if ($(e.target).is(".select-hover, .select-hover *")) {
      return;
    }

    $(".select-hover").each(function () {
      $(this).removeClass("active");
    });
  });

  $(".recipe-card").each(function () {
    new Swiper($(this), {
      effect: "fade",
      loop: true,

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: ".recipe-swiper-button-next",
        prevEl: ".recipe-swiper-button-prev",
      },
    });
  });
  /** End - recipe filters */

  var pageNumbers = {};

  $(".posts-section").each(function () {
    postsBarRender($(this));
    var type = $(this).attr("data-type");
    var index = getRowIndex($(this));
    pageNumbers[index] = 1;
    if (!$(this).find(".posts-container").hasClass("show-all")){
      loadPosts(
        type,
        index,
        null,
        false,
        "category",
        $(this).attr("data-posts-per-page"),
        $(this).attr("data-link-text")
      );
    }
  });

  function getPostsCount(target) {
    var initialPostsCount = $(target).children(".archive-column").length;
    return initialPostsCount;
  }

  function postsBarRender(target) {
    var index = getRowIndex($(target));
    var initialMaxPostsCount = parseInt($(`#total-resources-${index}`).text());
    var initialPostsCount = getPostsCount($(target));

    calculateBarLength(
      $(`#archive-count-bar-indicator-${index}`),
      initialPostsCount,
      initialMaxPostsCount,
      $(target).find(".archive-load-more")
    );
  }

  function loadPosts(
    type,
    index,
    categoryId,
    updateCategory,
    taxonomy,
    postsPerPage,
    linkText
  ) {

    $.ajax({
      url: settings.ajaxurl,
      type: "POST",
      data: {
        action: "more_post_ajax",
        linkText: linkText,
        postsPerPage: postsPerPage,
        pageNumber: pageNumbers[index],
        page_id: settings.page_id,
        type: type,
        category_id: categoryId ? categoryId : null,
        update_category: updateCategory ? updateCategory : false,
        taxonomy: taxonomy ? taxonomy : "category",
      },
      beforeSend: function () {
        $(".posts-section .filter-select").prop("disabled", true);
        $(".lds-dual-ring").text('Loading...');
        $(".archive-post-count").hide();
      }, 
      success: function (html) {
        var posts = html.html;
        $(`#post-excerpts-container-${index}`).append(posts);
        $(".posts-section .filter-select").prop("disabled", false);
        $(".lds-dual-ring").text('');
        $(".archive-post-count").show();
        if (html.total_post_count) {
          var maxPosts = html.total_post_count;
          $(`#total-resources-${index}`).text(maxPosts);
        } else {
          var maxPosts = parseInt($(`#total-resources-${index}`).text());
        }
        var countPosts = $(
          `#post-excerpts-container-${index} .archive-column`
        ).length;

        $(`#currently-shown-${index}`).text(countPosts);
        calculateBarLength(
          $(`#archive-count-bar-indicator-${index}`),
          countPosts,
          maxPosts,
          $(`#archive-load-more-${index}`)
        );
        pageNumbers[index]++;
      },
      fail: function () {
        $("#post-excerpts-container").append(
          '<p class="text-center">No more posts to load.</p>'
        );
      },
      complete: function () {
        $(".posts-section .btn-category").removeClass("disabled");
      },
    });
  }

  function calculateBarLength(target, current, max, button) {
    var lengthPercentage = Math.round((current / max) * 100);
    target.css("width", lengthPercentage + "%");
    if (current >= max) {
      disableTarget(button);
    } else {
      enableTarget(button);
    }
  }

  function disableTarget(target) {
    target.addClass("disabled");
  }

  function enableTarget(target) {
    target.removeClass("disabled");
  }

  function getRowIndex(target) {
    var rowIndex = target.data("row-index");
    return rowIndex;
  }

  function clearPosts(rowIndex) {
    $(`#archive-container-${rowIndex} .archive-column`).remove();
    pageNumbers[rowIndex] = 1;
  }

  function getParameters(target) {
    var type = $(target).parents(".posts-section").attr("data-type");
    var index = getRowIndex($(target).parents(".posts-section"));
    var categoryId = $(target)
      .parents(".posts-section")
      .attr("data-category-id");
    var taxonomy = $(target).parents(".posts-section").attr("data-taxonomy");
    var postsPerPage = $(target)
      .parents(".posts-section")
      .attr("data-posts-per-page");
    var linkText = $(target).parents(".posts-section").attr("data-link-text");

    return {
      type: type,
      index: index,
      categoryId: categoryId,
      taxonomy: taxonomy,
      postsPerPage: postsPerPage,
      linkText: linkText,
    };
  }

  $(".posts-section .btn-category").on("click", function (event) {
    event.preventDefault();
    $(this)
      .parents(".posts-section")
      .find(".btn-category")
      .removeClass("active");
    $(".posts-section .btn-category").addClass("disabled");
    $(this).addClass("active");
    $(this)
      .parents(".posts-section")
      .attr("data-category-id", $(this).attr("data-category-id"));
    var params = getParameters($(this));
    clearPosts(params.index);
    loadPosts(
      params.type,
      params.index,
      params.categoryId,
      true,
      params.taxonomy,
      params.postsPerPage
    );
  });

  $(document).on("click", ".archive-load-more", function (event) {
    event.preventDefault();
    disableTarget($(this));
    var params = getParameters($(this));
    loadPosts(
      params.type,
      params.index,
      params.categoryId,
      false,
      params.taxonomy,
      params.postsPerPage,
      params.linkText
    );
  });

  $(".posts-section .filter-select").on("change", function () {
    $(this).parents(".posts-section").attr("data-category-id", $(this).val());
    var params = getParameters($(this));
    clearPosts(params.index);
    loadPosts(
      params.type,
      params.index,
      params.categoryId,
      true,
      params.taxonomy,
      params.postsPerPage,
      params.linkText
    );
  });

  $(".posts-section .category-filter .category-buttons span").on(
    "click",
    function () {
      $(this)
        .parents(".posts-section")
        .attr("data-category-id", $(this).attr("data-category-id"));
      var params = getParameters($(this));
      clearPosts(params.index);
      loadPosts(
        params.type,
        params.index,
        params.categoryId,
        true,
        params.taxonomy,
        params.postsPerPage,
        params.linkText
      );
    }
  );

  /** Show video modal */
  $(document).on("click", ".trigger-video-modal", function () {
    var id = $(this).attr("data-id");

    $("html").removeClass("modal-open").addClass("modal-open");
    $(".modal").removeClass("active");
    $('.modal[data-id="' + id + '"]').addClass("active");
  });

  $(document).on("click", ".modal .close-btn", function () {
    $("html").removeClass("modal-open");
    $(".modal").removeClass("active");

    var $video = $(this).parents(".modal").find("video");
    $video.get(0).pause();
    $video.get(0).currentTime = 0;
  });

  /** Handle submission of Ninja Form for E-learning */
  function createCookie(name, value, days) {
    var expires;

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      encodeURIComponent(value) +
      expires +
      "; path=/";
  }

  $(document).on("nfFormSubmitResponse", function (e, response) {
    var id = response.id;

    if ($('.e-learning-wrapper[data-form-id="' + id + '"]').length > 0) {
      console.log("we should set a cookie here");
      createCookie("e-learning-form-success", id);
    }
  });

  $(document).on('click', '.search-nav', function () {
    $('body').addClass('search-overlay-active');
  });

  $(document).on('click', '.search-overlay-close', function () {
    $('body').removeClass('search-overlay-active');
  });
});

function getCookie(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

(function () {
  "use strict";

  // define variables
  var items = document.querySelectorAll(".timeline li");

  // check if an element is in viewport
  // http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function callbackFunc() {
    for (var i = 0; i < items.length; i++) {
      if (isElementInViewport(items[i])) {
        items[i].classList.add("in-view");
      }
    }
  }

  // listen for events
  window.addEventListener("load", callbackFunc);
  window.addEventListener("resize", callbackFunc);
  window.addEventListener("scroll", callbackFunc);

  /** Tchibo Modal */
  // search url for ?tchibo-redirect and trigger the modal
  if (window.location.href.indexOf('?tchibo-redirect') > -1 && $('body').hasClass('tchibo-modal-enabled')) {
    $('html').addClass('tchibo-modal-open');
    //add mutation observer to wait for .tchibo-modal to be added to the DOM
    var targetNode = document.body;
    var config = {
      childList: true,
      subtree: true
    };

    var callback = function (mutationsList, observer) {
      if ($('.tchibo-modal').length > 0) {
        openModal();
        observer.disconnect();
      }
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
    
  }

  function openModal() {
    $('.tchibo-modal').addClass('open');
    $('html').addClass('tchibo-modal-open');
  }

  /** Capitol Modal */
  // search url for ?capitol-redirect and trigger the modal
  if (window.location.href.indexOf('?capitol-redirect') > -1 && $('body').hasClass('capitol-modal-enabled')) {  
    $('html').addClass('capitol-modal-open');
    //add mutation observer to wait for .capitol-modal to be added to the DOM
    var targetNode = document.body;
    var config = {
      childList: true,
      subtree: true
    };
    var callback = function callback(mutationsList, observer) {
      if ($('.capitol-modal').length > 0) {
        openCapitolModal();
        observer.disconnect();
      }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
  function openCapitolModal() {
    $('.capitol-modal').addClass('open');
    $('html').addClass('capitol-modal-open');
  }

  /** Close modal */
  function closeModals() {
    $('.tchibo-modal').removeClass('open');
    $('.capitol-modal').removeClass('open');
    $('html').removeClass('tchibo-modal-open');
    $('html').removeClass('capitol-modal-open');
  }

  $(document).on('keyup', function (e) {
    e = e || window.event;
    var isEscape = false;
    if ('key' in e) {
      isEscape = (e.key === 'Escape' || e.key === 'Esc');
    } else {
      isEscape = (e.keyCode === 27);
    }

    if (isEscape) {
      closeModals();
    }
  });

  $(document).on('click', '.modal-overlay, .capitol-modal-overlay, .close-modal', function () {
    closeModals();
  });
})();


// WEBPACK FOOTER //
// ./scripts/autoload/jQuery.js